const EApplicationTerm = Object.freeze({
  Undefined: 0,
  Before: 10,
  After: 20,
  BeforeAndAfter: 30
});

export default EApplicationTerm;